import * as actions from '../actionTypes'
const initialState = [];

const assignmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.DELETE_ASSIGNMENT:
            return state.filter((assignment) => assignment._id !== action.payload);
        case actions.SET_ASSIGNMENTS:
            return action.payload;

        case actions.ADD_ASSIGNMENT:
            return [...state, action.payload];

        case actions.UPDATE_ASSIGNMENT: {
            return state.map((assignment) => assignment._id === action.payload._id ? action.payload : assignment);
        }
        default:
            return state;
    }
};

export default assignmentsReducer;

